import { useContext } from 'react';

import {
    Col,
    Container,
    Row,
} from 'react-bootstrap';

import {
    BrandingContext,
    GeoContext,
    InsuranceDataContext,
    LayoutContext,
    NotificationsContext,
    SessionContext,
} from '../libs/contexts.js';
import {
    BaseMobileFaq,
    BaseMobileFooter,
    BaseMobileHeader,
    BaseMobileMenu,
    BaseMobileProgressBar,
    BaseMobileSidebar,
} from './base-mobile.jsx';

export const HeroMobileLayout = ({ MyOutlet }) => {

    const { layout } = useContext(LayoutContext);


    return (

        <>
            <div className="content-container">
                <HeroMobileMenu />
                <Container fluid>
                    <Row>
                        <Col className="desktop-area px-0">
                            <Container fluid>
                                <Row>
                                    <Col className='px-0'>
                                        <Container fluid>
                                            <Row>
                                                <Col>
                                                    <HeroMobileHeader />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    {"yes" === layout.faq ?
                                                        <HeroMobileFaq />
                                                        :
                                                        <>
                                                            {"jump" === layout.specialView ?
                                                                <p>We are getting your quote ready, please hold...</p>
                                                                :
                                                                <MyOutlet></MyOutlet>
                                                            }</>

                                                    }

                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </Container>
            </div>

            {"end" !== layout.currentScreen &&
                <HeroMobileFooter />
            }


        </>
    )


}

export const HeroMobileFooter = () => {

    return (
        <>
            <BaseMobileFooter />
        </>
    );
}

export const HeroMobileHeader = () => {

    return (
        <>
            <BaseMobileHeader />
        </>
    )

}

export const HeroMobileMenu = () => {
    return (
        <BaseMobileMenu />
    )
}

export const HeroMobileProgressBar = () => {

    return (
        <BaseMobileProgressBar />
    )

}

export const HeroMobileSidebar = () => {

    return (
        <BaseMobileSidebar />
    )

}
